import { ActionExecutionRepository, ActionExecutionParams, ActionExecutionResult } from "../domain/ActionExecutionRepository";

export class ApiActionExecutionRepository implements ActionExecutionRepository {
  async executeAction(params: ActionExecutionParams): Promise<ActionExecutionResult> {
    const { async_command_dispatcher } = await import('@/api/client');

    const result = await async_command_dispatcher.dispatch_with_result('run.workflow.on.params', {
      params: params.params,
      company_id: params.company_id,
      workflow_template_id: params.workflow_template_id,
    });

    return result;
  }
}
